import config from "../config/config";
import { getToken } from "../utils/prefix"


export async function corpus_create(data) {
  const res = await fetch(config.api_backend + `/corpus/create`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function corpus_update(corpus_id, data) {
  const res = await fetch(config.api_backend + `/corpus/update`, {
    body: JSON.stringify({
      ...data,
      corpus_id: corpus_id
    }),
    method: "PUT",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function corpus_delete(data) {
  const res = await fetch(config.api_backend + `/corpus/delete`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function corpus_getAll(data) {
  const res = await fetch(config.api_backend + `/corpus/all`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function corpus_get(data) {
  const res = await fetch(config.api_backend + `/corpus/get`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function corpus_getSuggestion(data) {
  const res = await fetch(config.api_backend + `/corpus/getSuggestion`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function corpus_getById(data) {
  const res = await fetch(config.api_backend + `/corpus/getCorpusById`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function corpus_updateStatus(data) {
  const res = await fetch(config.api_backend + `/corpus/updateStatus`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function corpus_updateRevoked(data) {
  const res = await fetch(config.api_backend + `/corpus/updaterevoked`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

// Helper function สำหรับแปลง Blob เป็น Base64
function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // ตัดส่วน "data:...;base64," ออก แล้วเอาแต่ base64 string
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function corpus_uploadFile(data) {
  const {
    file,
    corpus_id,
    name = "",
    onProgress = null,
    chunkSize = 1024 * 1024 * 2 // 2MB default chunk size
  } = data;

  if (!file) {
    throw new Error("ยังไม่ได้เลือกไฟล์");
  }
  if (!corpus_id) {
    throw new Error("กรุณากรอก Corpus ID");
  }

  const fileSize = file.size;
  const totalChunks = Math.ceil(fileSize / chunkSize);
  const filename = file.name;
  const displayName = name || "";

  for (let currentIndex = 0; currentIndex < totalChunks; currentIndex++) {
    const start = currentIndex * chunkSize;
    const end = Math.min(start + chunkSize, fileSize);
    const blobChunk = file.slice(start, end);

    // แปลง chunk -> base64 แล้ว wrap เป็น Data URL
    const base64 = await blobToBase64(blobChunk);
    const dataUrl = `data:application/octet-stream;base64,${base64}`;

    // สร้าง query parameters ตามที่ backend คาดหวัง
    const params = new URLSearchParams({
      name: displayName,
      corpus_id: corpus_id,
      title: filename,
      currentChunkIndex: String(currentIndex),
      totalChunks: String(totalChunks),
    });

    const response = await fetch(config.api_backend + `/corpus/uploadChunk?${params.toString()}`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
        "x-access-token": getToken(),
      },
      body: dataUrl,
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(`Error uploading chunk ${currentIndex}: ${JSON.stringify(errData)}`);
    }

    const responseData = await response.json();

    // คำนวณ progress
    const percent = Math.round(((currentIndex + 1) / totalChunks) * 100);

    // เรียก callback สำหรับอัปเดต progress
    if (onProgress && typeof onProgress === 'function') {
      onProgress({
        currentChunk: currentIndex + 1,
        totalChunks,
        percent,
        response: responseData
      });
    }

    // ถ้าเป็น chunk สุดท้าย ให้ return response จาก backend
    if (currentIndex === totalChunks - 1) {
      return responseData;
    }
  }
}



export async function corpus_download(data) {
  const res = await fetch(config.api_backend + `/corpus/download`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  // Get filename from Content-Disposition header
  const contentDisposition = res.headers.get("Content-Disposition");
  let filename = "download";
  if (contentDisposition) {
    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (match && match[1]) {
      filename = match[1].replace(/['"]/g, "");
    }
  }

  const blob = await res.blob();
  return { blob, filename };
}